// YERİ: src/app/domains/site/sections/testimonials.section.ts
// Müvekkil yorumları — alıntı kartları.

import { Component, computed, input } from '@angular/core';
import { MIcon } from '@/app/shared/ui/m-icon';
import { SiteConfig, cfg } from './section.model';

interface Quote { quote: string; author: string; role?: string; }

@Component({
  selector: 'sec-testimonials',
  standalone: true,
  imports: [MIcon],
  template: `
    <section id="testimonials" class="bg-white py-24 dark:bg-neutral-950">
      <div class="mx-auto max-w-7xl px-6 lg:px-8">
        <div class="mx-auto max-w-2xl text-center">
          <p class="text-sm font-semibold uppercase tracking-widest" style="color:var(--site-accent)">{{ eyebrow() }}</p>
          <h2 class="mt-3 font-[family-name:var(--site-head-font)] text-3xl font-bold tracking-tight text-neutral-900 dark:text-white sm:text-4xl">{{ title() }}</h2>
        </div>
        <div class="mt-16 grid gap-6 lg:grid-cols-3">
          @for (q of items(); track q.author) {
            <figure class="flex flex-col rounded-2xl border border-neutral-200 bg-neutral-50 p-7 dark:border-neutral-800 dark:bg-neutral-900">
              <m-icon name="quote" class="!size-8" style="color:var(--site-accent)" />
              <blockquote class="mt-4 flex-auto text-neutral-700 dark:text-neutral-300">"{{ q.quote }}"</blockquote>
              <figcaption class="mt-6 border-t border-neutral-200 pt-4 dark:border-neutral-800">
                <p class="font-semibold text-neutral-900 dark:text-white">{{ q.author }}</p>
                @if (q.role) { <p class="text-sm text-neutral-500">{{ q.role }}</p> }
              </figcaption>
            </figure>
          }
        </div>
      </div>
    </section>
  `,
})
export class TestimonialsSection {
  config = input<SiteConfig>({});
  protected eyebrow = computed(() => cfg(this.config(), 'eyebrow', 'Referanslar'));
  protected title = computed(() => cfg(this.config(), 'title', 'Müvekkillerimiz Ne Diyor?'));
  protected items = computed<Quote[]>(() => cfg<Quote[]>(this.config(), 'items', [
    { quote: 'Sürecin her aşamasında bilgilendirildim ve sonuçtan çok memnun kaldım. Profesyonel bir ekip.', author: 'A. Kaya', role: 'Bireysel Müvekkil' },
    { quote: 'Şirketimizin ticari uyuşmazlığını büyük bir titizlikle çözdüler. Kesinlikle tavsiye ederim.', author: 'B. Şahin', role: 'Kurumsal Müvekkil' },
    { quote: 'Aile hukuku davamda gösterdikleri hassasiyet ve uzmanlık için minnettarım.', author: 'C. Yıldız', role: 'Bireysel Müvekkil' },
  ]));
}
